import AF from '../assets/flags/AF.png';
import AL from '../assets/flags/AL.png';
import DZ from '../assets/flags/DZ.png';
import AS from '../assets/flags/AS.png';
import AD from '../assets/flags/AD.png';
import AO from '../assets/flags/AO.png';
import AI from '../assets/flags/AI.png';
import AQ from '../assets/flags/AQ.png';
import AG from '../assets/flags/AG.png';
import AR from '../assets/flags/AR.png';
import AM from '../assets/flags/AM.png';
import AW from '../assets/flags/AW.png';
import AU from '../assets/flags/AU.png';
import AT from '../assets/flags/AT.png';
import AZ from '../assets/flags/AZ.png';
import BS from '../assets/flags/BS.png';
import BH from '../assets/flags/BH.png';
import BD from '../assets/flags/BD.png';
import BB from '../assets/flags/BB.png';
import BY from '../assets/flags/BY.png';
import BE from '../assets/flags/BE.png';
import BZ from '../assets/flags/BZ.png';
import BJ from '../assets/flags/BJ.png';
import BM from '../assets/flags/BM.png';
import BT from '../assets/flags/BT.png';
import BO from '../assets/flags/BO.png';
import BA from '../assets/flags/BA.png';
import BW from '../assets/flags/BW.png';
import BV from '../assets/flags/BV.png';
import BR from '../assets/flags/BR.png';
import IO from '../assets/flags/IO.png';
import VG from '../assets/flags/VG.png';
import BN from '../assets/flags/BN.png';
import BG from '../assets/flags/BG.png';
import BF from '../assets/flags/BF.png';
import BI from '../assets/flags/BI.png';
import KH from '../assets/flags/KH.png';
import CM from '../assets/flags/CM.png';
import CA from '../assets/flags/CA.png';
import CV from '../assets/flags/CV.png';
import KY from '../assets/flags/KY.png';
import CF from '../assets/flags/CF.png';
import TD from '../assets/flags/TD.png';
import CL from '../assets/flags/CL.png';
import CN from '../assets/flags/CN.png';
import CX from '../assets/flags/CX.png';
import CC from '../assets/flags/CC.png';
import CO from '../assets/flags/CO.png';
import KM from '../assets/flags/KM.png';
import CK from '../assets/flags/CK.png';
import CR from '../assets/flags/CR.png';
import HR from '../assets/flags/HR.png';
import CU from '../assets/flags/CU.png';
import CY from '../assets/flags/CY.png';
import CZ from '../assets/flags/CZ.png';
import CD from '../assets/flags/CD.png';
import DK from '../assets/flags/DK.png';
import DJ from '../assets/flags/DJ.png';
import DM from '../assets/flags/DM.png';
import DO from '../assets/flags/DO.png';
import TL from '../assets/flags/TL.png';
import EC from '../assets/flags/EC.png';
import EG from '../assets/flags/EG.png';
import SV from '../assets/flags/SV.png';
import GQ from '../assets/flags/GQ.png';
import ER from '../assets/flags/ER.png';
import EE from '../assets/flags/EE.png';
import ET from '../assets/flags/ET.png';
import FK from '../assets/flags/FK.png';
import FO from '../assets/flags/FO.png';
import FJ from '../assets/flags/FJ.png';
import FI from '../assets/flags/FI.png';
import FR from '../assets/flags/FR.png';
import GF from '../assets/flags/GF.png';
import PF from '../assets/flags/PF.png';
import TF from '../assets/flags/TF.png';
import GA from '../assets/flags/GA.png';
import GM from '../assets/flags/GM.png';
import GE from '../assets/flags/GE.png';
import DE from '../assets/flags/DE.png';
import GH from '../assets/flags/GH.png';
import GI from '../assets/flags/GI.png';
import GR from '../assets/flags/GR.png';
import GL from '../assets/flags/GL.png';
import GD from '../assets/flags/GD.png';
import GP from '../assets/flags/GP.png';
import GU from '../assets/flags/GU.png';
import GT from '../assets/flags/GT.png';
import GN from '../assets/flags/GN.png';
import GW from '../assets/flags/GW.png';
import GY from '../assets/flags/GY.png';
import HT from '../assets/flags/HT.png';
import HM from '../assets/flags/HM.png';
import HN from '../assets/flags/HN.png';
import HK from '../assets/flags/HK.png';
import HU from '../assets/flags/HU.png';
import IS from '../assets/flags/IS.png';
import IN from '../assets/flags/IN.png';
import ID from '../assets/flags/ID.png';
import IR from '../assets/flags/IR.png';
import IQ from '../assets/flags/IQ.png';
import IE from '../assets/flags/IE.png';
import IL from '../assets/flags/IL.png';
import IT from '../assets/flags/IT.png';
import CI from '../assets/flags/CI.png';
import JM from '../assets/flags/JM.png';
import JP from '../assets/flags/JP.png';
import JO from '../assets/flags/JO.png';
import KZ from '../assets/flags/KZ.png';
import KE from '../assets/flags/KE.png';
import KI from '../assets/flags/KI.png';
import KW from '../assets/flags/KW.png';
import KG from '../assets/flags/KG.png';
import LA from '../assets/flags/LA.png';
import LV from '../assets/flags/LV.png';
import LB from '../assets/flags/LB.png';
import LS from '../assets/flags/LS.png';
import LR from '../assets/flags/LR.png';
import LY from '../assets/flags/LY.png';
import LI from '../assets/flags/LI.png';
import LT from '../assets/flags/LT.png';
import LU from '../assets/flags/LU.png';
import MO from '../assets/flags/MO.png';
import MK from '../assets/flags/MK.png';
import MG from '../assets/flags/MG.png';
import MW from '../assets/flags/MW.png';
import MY from '../assets/flags/MY.png';
import MV from '../assets/flags/MV.png';
import ML from '../assets/flags/ML.png';
import MT from '../assets/flags/MT.png';
import MH from '../assets/flags/MH.png';
import MQ from '../assets/flags/MQ.png';
import MR from '../assets/flags/MR.png';
import MU from '../assets/flags/MU.png';
import YT from '../assets/flags/YT.png';
import MX from '../assets/flags/MX.png';
import FM from '../assets/flags/FM.png';
import MD from '../assets/flags/MD.png';
import MC from '../assets/flags/MC.png';
import MN from '../assets/flags/MN.png';
import MS from '../assets/flags/MS.png';
import MA from '../assets/flags/MA.png';
import MZ from '../assets/flags/MZ.png';
import MM from '../assets/flags/MM.png';
import NA from '../assets/flags/NA.png';
import NR from '../assets/flags/NR.png';
import NP from '../assets/flags/NP.png';
import NL from '../assets/flags/NL.png';
import AN from '../assets/flags/AN.png';
import NC from '../assets/flags/NC.png';
import NZ from '../assets/flags/NZ.png';
import NI from '../assets/flags/NI.png';
import NE from '../assets/flags/NE.png';
import NG from '../assets/flags/NG.png';
import NU from '../assets/flags/NU.png';
import NF from '../assets/flags/NF.png';
import KP from '../assets/flags/KP.png';
import MP from '../assets/flags/MP.png';
import NO from '../assets/flags/NO.png';
import OM from '../assets/flags/OM.png';
import PK from '../assets/flags/PK.png';
import PW from '../assets/flags/PW.png';
import PS from '../assets/flags/PS.png';
import PA from '../assets/flags/PA.png';
import PG from '../assets/flags/PG.png';
import PY from '../assets/flags/PY.png';
import PE from '../assets/flags/PE.png';
import PH from '../assets/flags/PH.png';
import PN from '../assets/flags/PN.png';
import PL from '../assets/flags/PL.png';
import PT from '../assets/flags/PT.png';
import PR from '../assets/flags/PR.png';
import QA from '../assets/flags/QA.png';
import CG from '../assets/flags/CG.png';
import RE from '../assets/flags/RE.png';
import RO from '../assets/flags/RO.png';
import RU from '../assets/flags/RU.png';
import RW from '../assets/flags/RW.png';
import SH from '../assets/flags/SH.png';
import KN from '../assets/flags/KN.png';
import LC from '../assets/flags/LC.png';
import PM from '../assets/flags/PM.png';
import VC from '../assets/flags/VC.png';
import WS from '../assets/flags/WS.png';
import SM from '../assets/flags/SM.png';
import ST from '../assets/flags/ST.png';
import SA from '../assets/flags/SA.png';
import SN from '../assets/flags/SN.png';
import CS from '../assets/flags/CS.png';
import SC from '../assets/flags/SC.png';
import SL from '../assets/flags/SL.png';
import SG from '../assets/flags/SG.png';
import SK from '../assets/flags/SK.png';
import SI from '../assets/flags/SI.png';
import SB from '../assets/flags/SB.png';
import SO from '../assets/flags/SO.png';
import ZA from '../assets/flags/ZA.png';
import GS from '../assets/flags/GS.png';
import KR from '../assets/flags/KR.png';
import ES from '../assets/flags/ES.png';
import LK from '../assets/flags/LK.png';
import SD from '../assets/flags/SD.png';
import SR from '../assets/flags/SR.png';
import SJ from '../assets/flags/SJ.png';
import SZ from '../assets/flags/SZ.png';
import SE from '../assets/flags/SE.png';
import CH from '../assets/flags/CH.png';
import SY from '../assets/flags/SY.png';
import TW from '../assets/flags/TW.png';
import TJ from '../assets/flags/TJ.png';
import TZ from '../assets/flags/TZ.png';
import TH from '../assets/flags/TH.png';
import TG from '../assets/flags/TG.png';
import TK from '../assets/flags/TK.png';
import TO from '../assets/flags/TO.png';
import TT from '../assets/flags/TT.png';
import TN from '../assets/flags/TN.png';
import TR from '../assets/flags/TR.png';
import TM from '../assets/flags/TM.png';
import TC from '../assets/flags/TC.png';
import TV from '../assets/flags/TV.png';
import VI from '../assets/flags/VI.png';
import UG from '../assets/flags/UG.png';
import UA from '../assets/flags/UA.png';
import AE from '../assets/flags/AE.png';
import GB from '../assets/flags/GB.png';
import US from '../assets/flags/US.png';
import UM from '../assets/flags/UM.png';
import UY from '../assets/flags/UY.png';
import UZ from '../assets/flags/UZ.png';
import VU from '../assets/flags/VU.png';
import VA from '../assets/flags/VA.png';
import VE from '../assets/flags/VE.png';
import VN from '../assets/flags/VN.png';
import WF from '../assets/flags/WF.png';
import EH from '../assets/flags/EH.png';
import YE from '../assets/flags/YE.png';
import ZM from '../assets/flags/ZM.png';
import ZW from '../assets/flags/ZW.png';
import EU from '../assets/flags/EU.png';

const flagImages: Record<string, string> = {
  AD,
  AE,
  AF,
  AG,
  AI,
  AL,
  AM,
  AN,
  AO,
  AQ,
  AR,
  AS,
  AT,
  AU,
  AW,
  AZ,
  BA,
  BB,
  BD,
  BE,
  BF,
  BG,
  BH,
  BI,
  BJ,
  BM,
  BN,
  BO,
  BR,
  BS,
  BT,
  BV,
  BW,
  BY,
  BZ,
  CA,
  CC,
  CD,
  CF,
  CG,
  CH,
  CI,
  CK,
  CL,
  CM,
  CN,
  CO,
  CR,
  CS,
  CU,
  CV,
  CX,
  CY,
  CZ,
  DE,
  DJ,
  DK,
  DM,
  DO,
  DZ,
  EC,
  EE,
  EG,
  EH,
  ER,
  ES,
  ET,
  FI,
  FJ,
  FK,
  FM,
  FO,
  FR,
  GA,
  GB,
  GD,
  GE,
  GF,
  GH,
  GI,
  GL,
  GM,
  GN,
  GP,
  GQ,
  GR,
  GS,
  GT,
  GU,
  GW,
  GY,
  HK,
  HM,
  HN,
  HR,
  HT,
  HU,
  ID,
  IE,
  IL,
  IN,
  IO,
  IQ,
  IR,
  IS,
  IT,
  JM,
  JO,
  JP,
  KE,
  KG,
  KH,
  KI,
  KM,
  KN,
  KP,
  KR,
  KW,
  KY,
  KZ,
  LA,
  LB,
  LC,
  LI,
  LK,
  LR,
  LS,
  LT,
  LU,
  LV,
  LY,
  MA,
  MC,
  MD,
  MG,
  MH,
  MK,
  ML,
  MM,
  MN,
  MO,
  MP,
  MQ,
  MR,
  MS,
  MT,
  MU,
  MV,
  MW,
  MX,
  MY,
  MZ,
  NA,
  NC,
  NE,
  NF,
  NG,
  NI,
  NL,
  NO,
  NP,
  NR,
  NU,
  NZ,
  OM,
  PA,
  PE,
  PF,
  PG,
  PH,
  PK,
  PL,
  PM,
  PN,
  PR,
  PS,
  PT,
  PW,
  PY,
  QA,
  RE,
  RO,
  RU,
  RW,
  SA,
  SB,
  SC,
  SD,
  SE,
  SG,
  SH,
  SI,
  SJ,
  SK,
  SL,
  SM,
  SN,
  SO,
  SR,
  ST,
  SV,
  SY,
  SZ,
  TC,
  TD,
  TF,
  TG,
  TH,
  TJ,
  TK,
  TL,
  TM,
  TN,
  TO,
  TR,
  TT,
  TV,
  TW,
  TZ,
  UA,
  UG,
  UM,
  US,
  UY,
  UZ,
  VA,
  VC,
  VE,
  VG,
  VI,
  VN,
  VU,
  WF,
  WS,
  YE,
  YT,
  ZA,
  ZM,
  ZW,
  EU,
};

export default flagImages;
